import SDKBuilder from "../utils/builder";
import api from "./api";
import configDeprecationWarnings from "../utils/configDeprecationWarnings";

/**
 * Factory for Web SDK creation.
 * Given a config object, returns a SDK object specialized for Web environment.
 *
 * @param environment
 * @param lang
 * @param networkRequestsTimeout
 * @param backendHosts
 * @param {Object} localCache An object containing four boolean properties: auth, layouts, titles, search. The SDK will
 * use local cache for the properties containing true as their value, and will discard cache for those having false.
 * This allows more granularity for the users of the SDK to cache some parts but leave others apart. Also, the
 * localCache property can be false if the cache needs to be disabled entirely.
 * @returns {SDKInstance}
 *
 * @example
 * const sdk = SDK({ lang: "es" });
 * media.getLayout("home"); // Will return a Promise with the homepage layout.
 * media.getMovies(ID); // Will return a Promise with the title requested by ID.
 */
export default (config = {}) => {
  configDeprecationWarnings(config);
  return SDKBuilder.SDK(api)(config);
};
